import axios from 'axios';
import { API_URL } from '../constants';

export default function globalAxios() {

  return (
    axios.create({
      baseURL: API_URL,
      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "uid": localStorage.getItem("uid")
      }
    })
  )
}